import flatten from 'lodash/flatten'

export function flattenRecursive<T>(array: T[], iteratee: (i: T) => any): T[] {
  if (!array || array.length === 0) return []
  return array.concat(flattenRecursive(flatten(array.map(i => iteratee(i) || [])), iteratee))
}
export default flattenRecursive
